import React, { useEffect, useState, forwardRef, Fragment } from "react";
import {
  Box,
  Grid,
  MenuItem,
  Typography,
  CircularProgress,
} from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import { emirates } from "../../resources/Mock";
import { DUBAI } from "../../resources/Constants";
import {
  NoBorderTextField,
  StyleHeading,
  StyleInputLabel,
  // StyledToggleButtonGroup,
  // StyledToggleButton,
  StyleTextField,
} from "../../assets/js/Theme";
import { injectIntl } from "react-intl";
import { doLocationSearch, doSearchForProperty } from "../../crud/search.crud";
import {
  capitalize,
  scrollToView,
  sendPageView,
  _trackActivity,
} from "../../resources/utils";

const SearchLocation = (props, ref) => {
  const {
    intl,
    setSelectedLocation,
    selectedLocation,
    selectedUnit,
    setSelectedUnit,
    scrollToPropertyDetail,
    errors,
    touched,
    currentSession,
    currentUser,
    parentRef
  } = props;
  const LIMIT = 50;
  const searchBy = "location";
  useEffect(() => {
    sendPageView("/property-search-screen");
  }, []);

  
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [locationData, setLocationData] = useState([]);
  const [propertyData, setPropertyData] = useState([]);
  const [unitData, setUnitData] = useState([]);
  const locationId = selectedLocation?.id || "";
  const [locationLoading, setLocationLoading] = useState(false);
  const [propertyLoading, setPropertyLoading] = useState(false);
  const [unitLoading, setUnitLoading] = useState(false);
  const [noLocationFound, setNoLocationFound] = useState(false);
  const [noUnitFound, setNoUnitFound] = useState(false);
  const defaultIsUnitSearch = searchBy === "dewa" || !locationId ? false : true;
  const [isUnitSearch, setIsUnitSearch] = useState(defaultIsUnitSearch);
  parentRef({
    resetSearch() {
      setIsUnitSearch(false);
      setLocationData([])
      setUnitData([])
    }
});
  const [timeoutId, setTimeoutId] = useState(0);

  const handleSearchInputExt = (values) => {
    if (searchBy !== "location" || values.columnType === "unit") {
      _fetchPropertySearchList(values);
    } else {
      _fetchLocations(values);
    }
  };
  
  const _handleSearchInput = (values) => {
    let textLength;
    if (values.columnType === "unit") {
      textLength = 0;
    } else {
      textLength = 2;
    }
    if (values.q && values.q.length > textLength) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      setTimeoutId(
        setTimeout(() => {
          handleSearchInputExt(values);
        }, 500)
      );
    }
  };

  const _fetchLocations = async (values) => {
    try {
      setLocationLoading(true);
      const queryParams = {
        emirateId: values.emirateId || DUBAI,
        q: values.q || "",
        limit: LIMIT,
      };
      const result = await doLocationSearch(queryParams);
      setLocationLoading(false);
      const { status, data } = result.data;
      if (status === 1) {
        setLocationData(data);
        if (data.length) {
          setNoLocationFound(false);
        } else {
          setNoLocationFound(true);
        }
      } else {
        console.log("locations is not populated");
      }
    } catch (e) {
      console.log(e);
      setLocationLoading(false);
    }
  };

  const _fetchPropertySearchList = async (values) => {
    try {
      const queryParams = {
        emirateId: values.emirateId || "",
        locationId,
        q: values.q,
        columnType: values.columnType || "",
        makaniNumber: values.makaniNumber || "",
        parcelId: values.parcelId || "",
        limit: LIMIT,
      };
      values.columnType === "unit"
        ? setUnitLoading(true)
        : setPropertyLoading(true);
      const result = await doSearchForProperty(queryParams);
      values.columnType === "unit"
        ? setUnitLoading(false)
        : setPropertyLoading(false);
      const { status, data } = result.data;
      if (status === 1) {
        values.columnType === "unit"
          ? setUnitData(data)
          : setPropertyData(data);
        if (data.length) {
          setNoUnitFound(false);
        } else {
          setNoUnitFound(true);
        }
      } else {
        console.log("property details is not populated");
      }
    } catch (e) {
      setUnitLoading(false);
      console.log(e);
    }
  };

  const [unitInputValue, setUnitInputValue] = React.useState("");
  const [propertyInputValue, setPropertyInputValue] = React.useState("");
  const [locationInputValue, setLocationInputValue] = React.useState("");
  const locationFilterOptions = (options, state) => {
    let data = [];
    if (state && state.inputValue) {
      data = options.filter((x) =>
        x?.alias.toLowerCase().includes(state.inputValue.toLowerCase())
      );
    }
    return data;
  };


  return (
    <Box className="search-loc-container  padding-md">
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} className="padding-sm">
          <NoBorderTextField
            type="text"
            select
            id="emirate"
            margin="dense"
            size="small"
            color="primary"
            variant="outlined"
            value={DUBAI}
            disabled
            //   onChange={handleChange}
          >
            {emirates.map((value) => (
              <MenuItem
                key={value.id}
                value={value.id}
                disabled={value.id !== DUBAI}
              >
                {value.name}
              </MenuItem>
            ))}
          </NoBorderTextField>
        </Grid>
        <Grid item xs={12} className="padding-sm">
          <StyleHeading color="primary" variant="h1">
            {intl.formatMessage({
              id: "HEADING.LETS_FIND_THE_PROPERTY",
            })}
          </StyleHeading>
        </Grid>
        {/* <Grid item xs={12} className="padding-sm search-type-wrapper">
          <InputLabel htmlFor="bootstrap-input">
            <StyledToggleButtonGroup
              exclusive
              aria-label="searchBy"
              name="searchBy"
              value={searchBy}
              onChange={(e, value) => {
                if (value) {
                  setSearchBy(value);
                  setLocationData([]);
                  setPropertyData([]);
                  setUnitData([]);
                  setSelectedLocation(null);
                  setSelectedProperty(null);
                  setSelectedUnit(null);
                  setLocationInputValue("");
                  setUnitInputValue("");
                  setPropertyInputValue("");
                  setIsUnitSearch(false);
                }
              }}
              size="medium"
            >
              <StyledToggleButton color="secondary" value="location">
                {intl.formatMessage({
                  id: "GENERAL.LOCATION",
                })}
              </StyledToggleButton>
              <StyledToggleButton color="secondary" value="makani">
                {intl.formatMessage({
                  id: "GENERAL.MAKANI",
                })}
              </StyledToggleButton>
              <StyledToggleButton color="secondary" value="dewa">
                {intl.formatMessage({
                  id: "GENERAL.DEWA",
                })}
              </StyledToggleButton>
              <StyledToggleButton color="secondary" value="parcel">
                {intl.formatMessage({
                  id: "GENERAL.PARCEL",
                })}
              </StyledToggleButton>
            </StyledToggleButtonGroup>
          </InputLabel>
        </Grid> */}
        <Grid item xs={12} className="padding-sm margin-top-20">
          <StyleInputLabel htmlFor="bootstrap-input" color="primary">
            {intl.formatMessage({
              id: "SEARCH_BY_LABEL",
            })}
          </StyleInputLabel>
          {searchBy === "location" ? (
            <Autocomplete
              id="location"
              // autoSelect
              options={locationData}
              value={selectedLocation}
              inputValue={locationInputValue}
              onInputChange={(event, newInputValue) => {
                setLocationInputValue(newInputValue);
              }}
              getOptionLabel={(option) => option.name}
              getOptionDisabled={(option) => !option.avm_status}
              filterOptions={locationFilterOptions}
              renderOption={(props, option, { selected }) => (
                <Fragment key={option.id}>
                  {option.avm_status === 0 ? (
                    <li {...props} >
                      <div className="full-width option--label--wrapper">
                        <Typography
                          color="primary"
                          component="span"
                          variant="body1"
                        >
                          {option.name}
                        </Typography>
                        <br />
                        <Typography
                          color="primary"
                          component="span"
                          variant="body2"
                          className="font-weight-400"
                        >
                          {intl.formatMessage({
                            id: "GENERAL.AVM_NOT_AVAILABLE",
                          })}
                        </Typography>
                      </div>
                    </li>
                  ) : (
                    <li {...props}>
                      <div className="full-width option--label--wrapper">
                        <Typography
                          color="primary"
                          component="span"
                          variant="body1"
                        >
                          {option.name}
                        </Typography>
                      </div>
                    </li>
                  )}
                </Fragment>
              )}
              onChange={(e, location) => {
                if (location) {
                  setSelectedLocation(location);
                  setIsUnitSearch(true);
                } else {
                  setSelectedLocation(null);
                  setSelectedUnit(null);
                  setIsUnitSearch(false);
                  setUnitData([]);
                }
              }}
              loading={locationLoading}
              noOptionsText={
                noLocationFound ? "Location not found" : "Enter location"
              }
              renderInput={(params) => (
                <StyleTextField
                  {...params}
                  onChange={(e) => {
                    const filters = {
                      emirateId: DUBAI,
                      q: e.target.value,
                    };
                    _handleSearchInput(filters);
                  }}
                  placeholder={`Example: "Princess Tower, Dubai Marina"  or "Springs 4, The Springs"`}
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <Fragment>
                        {locationLoading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </Fragment>
                    ),
                  }}
                />
              )}
            />
          ) : (
            <Autocomplete
              id="property"
              // autoSelect
              options={propertyData}
              value={selectedProperty}
              inputValue={propertyInputValue}
              onInputChange={(event, newInputValue) => {
                setPropertyInputValue(newInputValue);
              }}
              getOptionLabel={(option) =>
                searchBy === "makani" && option.makani_number
                  ? option.makani_number
                  : searchBy === "dewa" && option.dewa_number
                  ? option.dewa_number
                  : searchBy === "parcel"
                  ? `${option.parcel_id}`
                  : ""
              }
              loading={propertyLoading}
              onChange={(e, property) => {
                if (property) {
                  setSelectedProperty(property);
                  if (searchBy === "dewa") {
                    setSelectedUnit(property);
                    // return;
                  } else {
                    setIsUnitSearch(true);
                  }
                } else {
                  setSelectedProperty(null);
                  setSelectedUnit(null);
                  setIsUnitSearch(false);
                  setUnitData([]);
                }
              }}
              noOptionsText={
                noUnitFound
                  ? `Property not found`
                  : `Enter ${capitalize(searchBy)}`
              }
              renderInput={(params) => (
                <StyleTextField
                  {...params}
                  onChange={(e) => {
                    const filters = {
                      emirateId: DUBAI,
                      q: e.target.value,
                      columnType: searchBy,
                    };
                    _handleSearchInput(filters);
                  }}
                  placeholder={`Search by ${searchBy}`}
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {propertyLoading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          )}
        </Grid>
        <Grid item xs={12} md={6} className="padding-sm">
          <Autocomplete
            id="unit-no"
            // autoSelect
            options={unitData}
            value={selectedUnit}
            inputValue={unitInputValue}
            onInputChange={(event, newInputValue) => {
              setUnitInputValue(newInputValue);
              !newInputValue && setSelectedUnit(null);
            }}
            getOptionLabel={(option) => option.unit_number || ""}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <div className="full-width option--label--wrapper">
                  <Typography color="primary" component="span" variant="body1">
                    {option.unit_number}
                  </Typography>
                  <br />
                  <Typography color="primary" component="span" variant="body2">
                    {option.sub_title}
                  </Typography>
                </div>
              </li>
            )}
            filterOptions={(options, state) => {
              let data = [];
              if (state && state.inputValue) {
                data =
                  options.length &&
                  options.filter(
                    (x) =>
                      x.unit_number &&
                      x.unit_number
                        .toLowerCase()
                        .includes(state.inputValue.toLowerCase())
                  );
                if (!data.length) {
                  data = [
                    {
                      unit_number: state.inputValue,
                      location_id: locationId,
                      longitude: selectedLocation?.longitude,
                      latitude: selectedLocation?.latitude,
                      property_type_id: "",
                      bedrooms: "",
                      built_up_area_sqft: "",
                      property_new_address: `Property No. ${state.inputValue} ${selectedLocation?.name}, Dubai, United Arab Emirates`,
                    },
                  ];
                }
              }
              return data;
            }}
            loading={unitLoading}
            onChange={(e, unit) => {
              if (unit) {
                setSelectedUnit(unit);
                const postParams = {
                  event: "unit-search",
                  action: "search",
                  status: `A unit search has been done for unit No: ${unit?.unit_number} from location Id: ${unit?.location_id}`,
                  context: "location-search",
                  currentSession,
                  userId: currentUser?.user_id || "",
                  userConsumerId: currentUser?.userConsumerId || "",
                };
                _trackActivity(postParams);
                scrollToView(scrollToPropertyDetail, "propertyDetail");
              }
            }}
            noOptionsText={noUnitFound ? "Unit not found" : "Enter Unit No"}
            renderInput={(params) => (
              <StyleTextField
                helperText={touched.unitNumber && errors.unitNumber}
                error={Boolean(touched.unitNumber && errors.unitNumber)}
                {...params}
                onChange={(e) => {
                  const filters = {
                    emirateId: DUBAI,
                    q: e.target.value,
                    columnType: "unit",
                  };
                  if (selectedProperty && searchBy === "makani") {
                    filters.makaniNumber = selectedProperty.makani_number;
                  } else if (selectedProperty && searchBy === "parcel") {
                    filters.parcelId = selectedProperty.parcel_id;
                  }
                  _handleSearchInput(filters);
                }}
                variant="outlined"
                name="unitNumber"
                placeholder={intl.formatMessage({
                  id: "FORM.LABEL.SEARCH_FOR_UNIT_NUMBER",
                })}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {unitLoading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
            disabled={!isUnitSearch}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default injectIntl(forwardRef(SearchLocation));
